import {
  findDeepGetTask,
  isGrouped,
  recursiveGetStartForParent
} from '../../GanttVisualization.helper';
import { getIsOdd } from '../common/validators';
import {
  createNonTaskDateHtml,
  createTaskDateHtml,
  createPendingContent
} from './templates';
import { formatDate } from './utils';

const renderStart = ({ task, onlyRead, t }) => {
  const gantt = window.ganttVisualization;
  const activities = window.activities;
  const isOdd = getIsOdd({ gantt, task }, 'start_date');
  if (!task || task.is_milestone || isGrouped()) return null;

  if (!task.isTask) {
    const dateStr = formatDate(task.start_date, gantt);
    return createNonTaskDateHtml(dateStr, onlyRead);
  }
  if (task.modificationSource === 'pending') {
    const dateStr = formatDate(task.start_date, gantt);
    return createPendingContent(dateStr, isOdd, task, t);
  }

  const taskFromLookahead = findDeepGetTask(activities, 'id', task.id);
  if (!taskFromLookahead) return null;

  if (taskFromLookahead.children?.length) {
    recursiveGetStartForParent(
      taskFromLookahead,
      { name: 'start_date' },
      gantt
    );
  }

  const dateStr = formatDate(task.start_date, gantt);

  return createTaskDateHtml({ dateStr, onlyRead, isOdd, task, t });
};

export default renderStart;
